<mat-dialog-content>
  <mat-form-field>
    <mat-label>Select Role</mat-label>
    <mat-select [formControl]="userRole">
      <mat-option *ngFor='let role of userRoles' [value]='role'>{{role}}</mat-option>
    </mat-select>
  </mat-form-field>
  <div mat-dialog-actions class="row">
    <div class="col text-center">
      <button mat-button mat-dialog-close="" (click)="cookieStorageService.clearAllCookies()">Close</button>
      <button mat-button mat-dialog-close="" [disabled]="userRole.invalid" (click)='setActiveRole()'>Ok</button>
    </div>
  </div>
</mat-dialog-content>
